module.exports = __webpack_public_path__ + "static/media/First_page 2.5bb18d9f.svg";